import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Delete unavailability series
 * @param blockedIntervalSeriesUuid blockedIntervalSeriesUuid
 */
export default async function deleteBlockedIntervalSeries(
  blockedIntervalSeriesUuid: string,
) {
  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/unavailability/series/${blockedIntervalSeriesUuid}`,
    { method: "DELETE" },
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }
  return res;
}
